<template>
  <wrapper class="clt-w">
    <header class="clt-header aflex v-center">
      <span class="title">专属育儿顾问</span>
      <span class="tip">*如有任何月嫂问题，请联系她</span>
    </header>
    <div class="clt-info aflex">
      <div class="item aflex">
        <avatar class="clt-img" :url="consultant.inviteHeadImage" />
        <div class="aflex v justify-center">
          <div class="name">{{ consultant.inviteName }}</div>
          <div class="tel">{{ TEL }}</div>
        </div>
      </div>
      <a class="r aflex v center" :href="`tel:${consultant.inviteMobile}`">
        <img src="~@/assets/images/order/icon-tel3.png" />
        <span>联系她</span>
      </a>
    </div>
  </wrapper>
</template>
<script>
import wrapper from '../../wrapper'
import avatar from '@/components/avatar'
import { isEmptyObject, maskTEL } from '@/utils'
export default {
  components: {
    wrapper,
    avatar
  },
  props: {
    consultant: {
      type: Object,
      default() {
        return {
          // inviteHeadImage: '',
          // inviteName: '测试',
          // inviteMoblie: '133345670987',
        }
      }
    }
  },
  computed: {
    isShow() {
      return !isEmptyObject(this.consultant)
    },
    TEL() {
      return maskTEL(this.consultant.inviteMobile)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.clt-w {
  padding: 0;
  padding: rem(40px) rem(48px) rem(40px) rem(24px);
}
.clt-header {
  margin-bottom: rem(32px);
}
.title {
  font-size: rem(28px);
  color: #000000;
  line-height: rem(34px);
  font-weight: bold;
}
.tip {
  font-size: rem(24px);
  color: #ff9447;
  line-height: rem(30px);
  margin-left: rem(16px);
}
.clt-img {
  width: rem(90px) !important;
  height: rem(90px) !important;
  border-radius: 50%;
  margin-right: rem(12px);
}
.clt-info {
  .item {
    @include border(right, #d8d8d8, 1px);
  }
  .name {
    font-size: rem(26px);
    font-weight: 500;
    color: #333;
    line-height: rem(32px);
    margin-bottom: rem(8px);
  }
  .tel {
    font-size: rem(24px);
    color: #999;
    line-height: rem(30px);
  }
  .r {
    font-size: rem(24px);
    color: #ff5900;
    text-align: center;
    line-height: rem(30px);
    padding-left: rem(48px);
    img {
      width: rem(32px);
      margin-bottom: rem(6px);
    }
  }
}
</style>
